module.exports = __webpack_public_path__ + "media/images/icons/note-7e2c51793327d360d829235b3d74087e.svg";